/**
 * Tenant LiveKit avatar session API — availability probe + session mint.
 *
 * Backs the voice/avatar call mode in the Luma AI chat side panel. A thin
 * named adapter over the ORVAL-GENERATED fetchers (JSON-schema-first: the
 * request/response types come from the backend's OpenAPI, never hand-authored),
 * so the call sites read as `avatarSessionApi.createSession(...)` instead of
 * `startAvatarSessionApiV1AvatarsLivekitSessionsPost(...)`.
 *
 * The browser receives only a short-lived room-scoped token; the PanLuma JWT
 * reaches the agent via server-side dispatch metadata (never this layer).
 */
import {
  getLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet,
  startAvatarSessionApiV1AvatarsLivekitSessionsPost,
} from '../../../generated/api/avatars/avatars';
import type { LivekitAvailabilityResponse } from '../../../generated/api/models/livekitAvailabilityResponse';
import type { LivekitSessionRequest } from '../../../generated/api/models/livekitSessionRequest';
import type { LivekitSessionResponse } from '../../../generated/api/models/livekitSessionResponse';

export type {
  LivekitAvailabilityResponse,
  LivekitSessionRequest,
  LivekitSessionResponse,
};

export const avatarSessionApi = {
  /** Whether the deployment has LiveKit configured (gates the call button). */
  getAvailability: (): Promise<LivekitAvailabilityResponse> =>
    getLivekitAvailabilityApiV1AvatarsLivekitAvailabilityGet(),

  /**
   * Mint a session. `chat_id` binds the call to a chat so the worker mirrors
   * that chat's persona + tools and flushes the transcript back into it.
   */
  createSession: (request: LivekitSessionRequest): Promise<LivekitSessionResponse> =>
    startAvatarSessionApiV1AvatarsLivekitSessionsPost(request),
};
